import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UxService } from '~/app/core/services';
import { RoleService } from '../../core/services';
import { ComponentType } from '../models/component-type.model';
import { CarApi } from './car-api.base';

@Injectable()
export class ComponentTypeService extends CarApi<ComponentType> {
  constructor(
    http: HttpClient,
    roleService: RoleService,
    uxService: UxService) {
    super('component-types', http, roleService, uxService);
  }
}
